import axios from "axios";
import {axiosAuthHeader} from "config/axiosConfig";
import api from "../api";

export const getDepositCrypto = async (depositId: string) => {
    return api.get(`/crypto-buy-template?docId=${depositId}`,axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })

}

export const getDepositFee = async (deposit_amount: number) => {
    return api.get(`/fee/deposit?depositAmount=${deposit_amount}`,axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })

}
